import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// ПРОВЕРЬ: Если файлы называются Header.jsx, добавь расширение .jsx в конце пути
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import {
  DocumentTextIcon,
  CalendarDaysIcon,
  TagIcon,
  UserIcon,
  EyeIcon,
  ArrowRightIcon,
  MagnifyingGlassIcon
} from '@heroicons/react/24/outline';

const BlogPage = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPosts, setTotalPosts] = useState(0);
  const postsPerPage = 9;

  useEffect(() => {
    loadBlogPosts();
  }, [currentPage, selectedCategory]);

  const loadBlogPosts = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: currentPage.toString(),
        limit: postsPerPage.toString()
      });
      
      if (selectedCategory) {
        params.append('category', selectedCategory);
      }

      const response = await fetch(`/api/v1/public/blog?${params}`);
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setBlogPosts(data.data || []);
          setTotalPosts(data.pagination?.total || 0);
        }
      }
    } catch (error) {
      console.error('Failed to load blog posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const categories = ['Pet Care', 'Health', 'Grooming', 'Training', 'Nutrition', 'Veterinary', 'Product Reviews', 'Tips & Guides'];

  const filteredPosts = blogPosts.filter(post => {
    if (!searchTerm) return true;
    const searchLower = searchTerm.toLowerCase();
    return (
      post.title?.toLowerCase().includes(searchLower) ||
      post.excerpt?.toLowerCase().includes(searchLower)
    );
  });

  const totalPages = Math.ceil(totalPosts / postsPerPage);

  if (loading && currentPage === 1) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header />
        <div className="flex-1 flex justify-center items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="bg-gradient-to-r from-green-600 to-green-700 py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-black text-white sm:text-6xl tracking-tighter">Zootel Blog</h1>
          <p className="mt-4 text-green-100">Expert advice for your furry friends.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Search & Filter */}
        <div className="grid md:grid-cols-2 gap-6 mb-12 bg-white p-6 rounded-3xl shadow-sm border border-slate-100">
           <input 
             type="text" 
             placeholder="Search articles..." 
             className="px-4 py-3 rounded-xl bg-slate-50 border-none focus:ring-2 focus:ring-green-500 outline-none"
             onChange={(e) => setSearchTerm(e.target.value)}
           />
           <select 
             className="px-4 py-3 rounded-xl bg-slate-50 border-none focus:ring-2 focus:ring-green-500 outline-none"
             onChange={(e) => setSelectedCategory(e.target.value)}
           >
             <option value="">All Categories</option>
             {categories.map(c => <option key={c} value={c}>{c}</option>)}
           </select>
        </div>

        {/* Posts Grid */}
        <div className="grid gap-8 md:grid-cols-3">
          {filteredPosts.map((post) => (
            <article key={post.id} className="bg-white rounded-[2rem] overflow-hidden border border-slate-100 hover:shadow-xl transition-all group">
              <div className="h-48 bg-slate-200 overflow-hidden">
                {post.image_url && <img src={post.image_url} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform" />}
              </div>
              <div className="p-8">
                <span className="text-[10px] font-black uppercase tracking-widest text-green-600">{post.category}</span>
                <h2 className="text-xl font-bold text-slate-900 mt-2 mb-4 line-clamp-2">{post.title}</h2>
                <Link to={`/blog/${post.slug}`} className="text-sm font-bold text-slate-900 flex items-center gap-2 hover:gap-3 transition-all">
                  Read More <ArrowRightIcon className="h-4 w-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogPage;